import { styled } from "@mui/material/styles";

// Components
import CategoryIcon from "../CategoryIcon";

const styledName = "IconList";

export const StyledListWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    overflowY: "scroll",
  },
  // gap: "10px"
});

export const StyledIconItem = styled(CategoryIcon, { name: styledName })({
  "&": {
    height: "70px",
    width: "70px",
    padding: "14px",
    transition: "all 0.2s ease-in",
    ":hover": {
      padding: "8px",
    },
  },
});
